import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Globe } from 'lucide-react';
import GoogleTranslate from './GoogleTranslate';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showTranslate, setShowTranslate] = useState(false);
  const location = useLocation();

  const menuItems = [
    { name: 'Inicio', path: '/', id: 'inicio' },
    { name: 'Certificación', path: '/certificacion', id: 'certificacion' },
    { name: 'Acerca de GRANA', path: '/acerca', id: 'acerca' },
    { name: 'Recursos', path: '/recursos', id: 'recursos' },
    { name: 'Noticias', path: '/noticias', id: 'noticias' },
    { name: 'Contacto', path: '/contacto', id: 'contacto' }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-white shadow-sm border-b-2 border-orange-600 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="flex items-center space-x-3">
              <img
                src="/assets/images/cdl_naraja.png"
                alt="CDL Logo"
                className="h-16 w-16"
              />
              <img
                src="https://granacertification.org/wp-content/uploads/2022/07/logo-header.jpg"
                alt="GRANA Logo"
                className="h-12 w-auto rounded-full border-2 border-orange-200 bg-white p-1 hidden sm:block"
              />
            </div>
            <div className="ml-3">
              <h1 className="text-lg font-bold text-gray-800 leading-tight">
                Certificación Internacional <br />
                Competencias para la <br />
                Docencia en Línea
              </h1>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8">
            {menuItems.map((item) => (
              <Link
                key={item.id}
                to={item.path}
                className={`text-sm font-medium transition-colors duration-200 relative px-3 py-2 ${isActive(item.path)
                    ? 'text-orange-700 border-b-2 border-orange-600'
                    : 'text-gray-700 hover:text-orange-600'
                  }`}
              >
                {item.name}
              </Link>
            ))}
            <button
              className="flex items-center justify-center p-2 rounded-full hover:bg-gray-100 transition"
              aria-label="Seleccionar idioma"
              onClick={() => {
                setShowTranslate((v) => !v);
                setTimeout(() => {
                  const widget = document.getElementById('gt-widget');
                  if (widget) widget.classList.toggle('visible');
                }, 50);
              }}
              type="button"
            >
              <Globe size={22} className="text-gray-700" />
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-orange-600 hover:bg-gray-100"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4">
            <nav className="flex flex-col space-y-2">
              {menuItems.map((item) => (
                <Link
                  key={item.id}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${isActive(item.path)
                      ? 'text-orange-700 bg-orange-50 border-l-4 border-orange-600'
                      : 'text-gray-700 hover:text-orange-600 hover:bg-gray-50'
                    }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;